function isLimitedSlot(slot, slotRestrictionsOfInterest) {
  if (slotRestrictionsOfInterest === undefined) {
    // If customization isn't defined, default to old logic

    return (
      (slot.noNurse || slot.noHygienist || slot.noDoctor) &&
      (!slot.noNurse || !slot.noHygienist || !slot.noDoctor)
    );
  } else if (slotRestrictionsOfInterest.length === 0) {
    // If the customization is defined, but empty, there are no slot restrictions of interest
    // - this means that no slot is limited
    return false;
  } else {
    const restrictionCountOfSlot = getSlotRestrictionOfInterestCount(
      slot,
      slotRestrictionsOfInterest,
    );

    if (restrictionCountOfSlot > 0) {
      // Slot has at least one restriction of interest, so availability is shown as limited
      return true;
    }
  }
  return false;
}

function isAvailableSlot(slot, slotRestrictionsOfInterest) {
  if (
    slotRestrictionsOfInterest === undefined ||
    slotRestrictionsOfInterest.length === 0
  ) {
    // If customization isn't defined, default to old logic
    return !(slot.noNurse && slot.noHygienist && slot.noDoctor);
  } else {
    const restrictionCountOfSlot = getSlotRestrictionOfInterestCount(
      slot,
      slotRestrictionsOfInterest,
    );

    if (restrictionCountOfSlot === slotRestrictionsOfInterest.length) {
      // Slot has all the restrictions of interest, so no treatments are available
      return false;
    }
  }
  return true;
}

function getSlotRestrictionOfInterestCount(slot, slotRestrictionsOfInterest) {
  let restrictionCountOfSlot = 0;

  for (const restriction of slotRestrictionsOfInterest) {
    if (slot[`${restriction}`] === true) {
      // If a restriction of interest if found on the slot, increase counter
      restrictionCountOfSlot++;
    }
  }
  return restrictionCountOfSlot;
}

/* Exports */
export { isLimitedSlot, isAvailableSlot };



// WEBPACK FOOTER //
// ./src/utils/slotHelpers.js